import { packValidateResults, required } from 'helpers/validators';
import { CreateApiKeyProps } from 'services/API/Keys/interface';

export const validate = (data: CreateApiKeyProps) =>
  packValidateResults([required(data, Object.keys(data))]);
